/**
 * Pontos de foco entre o chat e o painel de detalhes, para a página da conversa devolver o foco
 * quando uma das duas colunas some (layout médio/estreito) sem conhecer o HTML delas. Cada lado
 * escreve o atributo no elemento certo; os testes conferem os dois nomes.
 */
export const FOCUS_TARGET_ATTRIBUTE = 'data-focus-target';
/** Título do painel de detalhes (precisa de `tabIndex={-1}`). */
export const DETAILS_HEADING_TARGET = 'details-heading';
/** Link "Detalhes" do cabeçalho do chat (só existe em layout médio/estreito). */
export const DETAILS_LINK_TARGET = 'details-link';
/** Link "Voltar para as conversas" do cabeçalho do chat (só existe em layout estreito). */
export const BACK_TO_LIST_TARGET = 'back-to-list';
/** Campo de resposta do chat. */
export const COMPOSER_TARGET = 'composer';
